import { Typography } from "@drone-js/core";
import { memo } from "react";
import { useStaticDataAtomValue } from "../../staticDataAtom";

export const FirstPayoutNote = memo(() => {
    const {
        cmsData: {
            pricing: { noteYourFirstPayoutWillBeMade30DaysAfterTheCheckOutDate },
        },
    } = useStaticDataAtomValue();

    return (
        <Typography variant="caption-default" textColor="base.subtle">
            {noteYourFirstPayoutWillBeMade30DaysAfterTheCheckOutDate}
        </Typography>
    );
});
